import i18n from '@/i18n';

/**
 * 在非组件模块（如 axios 拦截器）中调用，与 this.$t 使用同一套 messages。
 * @param {string} key
 * @param {Record<string, unknown>} [values]
 * @returns {string}
 */
export function t(key, values) {
    if (values != null) {
        return i18n.global.t(key, values);
    }
    return i18n.global.t(key);
}
